import React from "react";
import CustomIconControllerComp from "./CustomIconControllerComp";
import { useState } from "react";
import { useSelector } from "react-redux";
import CustomizeComp from "../../Aside2Components/CustomizeComp";
import {
  getL2SheetProperty,
} from "../../../WorkbookSlice";
import ExpandableWithToggle from "../../../../../components/BasicComponents/ExpandableWithToggle";
export default function IconControllerComp({
  ControllerProps,
  currentSheet,
  parentKey,
  dispatchItemToredux,
  VizchartType,
}) {
  const { title, reduxKey, itemInArray, innerComponents } = ControllerProps;
  const [customIconModal, setCustomIconModal] = useState(false);
  const [selectedOtion, setSelectedOtion] = useState(null);
  // console.log(selectedOtion);
  const handleChange = (e) => {
    setSelectedOtion(e.target.value);
    if (e.target.value === "default") {
      dispatchItemToredux(false, "isIconVisible");
    } else if (e.target.value === "custom") {
      dispatchItemToredux(true, "isIconVisible");
    }
  };
  const { Sheetid } = currentSheet;
  const isIconVisible = useSelector((customIconModal) => {
    getL2SheetProperty(
      customIconModal,
      Sheetid,
      "customization",
      "isIconVisible"
    );
  });
  const { defaultValue } = ControllerProps;
  return (
    <main className="w-full flex gap-2 justify-center items-center h-[100%]">
      <ExpandableWithToggle
        ControllerProps={ControllerProps}
        currentSheet={currentSheet}
        dispatchItemToredux={dispatchItemToredux}
        defaultValue={defaultValue}
        componentType="CONTAINER_WITH_CUSTOM_BUTTON"
        customButtonState={setCustomIconModal}
      >
        {innerComponents.map((Controller, i) => (
          <CustomizeComp
            key={i}
            ControllerProps={Controller}
            parentKey="customization"
            currentSheet={currentSheet}
            reduxKey={reduxKey}
          />
        ))}
      </ExpandableWithToggle>
      {customIconModal ? (
        <CustomIconControllerComp
          setCustomIconModal={setCustomIconModal}
          Sheetid={Sheetid}
          VizchartType={VizchartType}
        />
      ) : null}
    </main>
  );
}
